export const NEW_RECORD_PATH = 'neue'
export const DATE_FORMAT = 'DD.MM.YYYY'
export const TIME_FORMAT = 'HH:mm:ss'
export const DATE_TIME_FORMAT = 'DD.MM.YYYY HH:mm:ss'
export const LIST_QUERY_LIMIT = 100
export const INIT_OFFSET = 0
export const INIT_QUERY_PARAMS = {
	defaultParams: {
		sort: [],
		limit: LIST_QUERY_LIMIT,
		cursors: { limit: LIST_QUERY_LIMIT },
		offset: INIT_OFFSET
	},
	defaultLimit: LIST_QUERY_LIMIT
}

export const IS_LOCALHOST = Boolean(
	window.location.hostname === 'localhost' ||
    // [::1] is the IPv6 localhost address.
    window.location.hostname === '[::1]' ||
    // 127.0.0.1/8 is considered localhost for IPv4.
    window.location.hostname.match(
    	/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/
    )
)
